import { ictAxios as axios } from "@plm/o10-share-front";
import { instance } from '@posco/posco-shared';
import { Common } from "@plm/o10-share-front";


class PortalRepository {

  @instance
  static instance;

  apiUrl = '/o10t01-portal';
  apiUrl_g = '/o10g01-invcommon';
  apiUrl_r = '/o10rq0-readonly';

  // 사용자 등록
  onCreateEmp(userInfo) {
    return axios.post(`${this.apiUrl}/login/user`, userInfo)
      .then(response => response);
  }
  // 로그인
  //return  Posco.auth.userMenu, Posco.auth.userInfo
  onLogin(idInfo) {
    return axios.post(`${this.apiUrl_g}/login`, idInfo)
      .then(response => response);
  }
  // 사업메뉴
  //return Posco.auth.invbpInfo,Posco.auth.userMenuByMenuCode, Posco.auth.InvestPurposeCode
  onGetProjectMenu(ProjectNumber) {
    const data = {
      gcsCompCode: Common.PotalUtil.getStorageItem('Posco.auth.userInfo').gcsCompCode,
      positiongroupName: Common.PotalUtil.getStorageItem('Posco.auth.userInfo').positiongroupName,
      organizationCode: Common.PotalUtil.getStorageItem('Posco.auth.userInfo').organizationCode,
      adminUser: Common.PotalUtil.getStorageItem('Posco.auth.userInfo').adminUser,
      chiefUser: Common.PotalUtil.getStorageItem('Posco.auth.userInfo').chiefUser,
      employeeNumber: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").employeeNumber,
      isProjectDeptUser: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").isProjectDeptUser,
      auditUser: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").auditUser,
      budgetUser: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").budgetUser,
      bizRegCode: ProjectNumber,
      
      //0511 추가
      reviewerE: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").reviewerE,
      reviewerM: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").reviewerM,
      evalE: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").evalE,
      evalM: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").evalM,
    }
    return axios.post(`${this.apiUrl_r}/invbpLogin`, data)
      .then(response => response);
  }

  //즐겨찾기 조회
  getFavorites() {
    const data = {
      gcsCompCode: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").gcsCompCode,
      employeeNumber: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").employeeNumber,
      typeCode: "A" //A 고정
    };
    return axios.post(`${this.apiUrl_r}/menu020/favorites`, data, {spinner: false})
      .then(response => response);
  }

  addFavorites(pattMenuId) {
    const data = {
      gcsCompCode: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").gcsCompCode,
      employeeNumber: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").employeeNumber,
      typeCode: "A", //A 고정
      pattMenuId: pattMenuId
    };
    return axios.post(`${this.apiUrl_g}/menu020`, data, {spinner: false})
      .then(response => response);
  }

  deleteFavorites(pattMenuId) {
    const data = {
      gcsCompCode: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").gcsCompCode,
      employeeNumber: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").employeeNumber,
      typeCode: "A", //A 고정
      pattMenuId: pattMenuId
    };
    return axios.delete(`${this.apiUrl_g}/menu020/${data.gcsCompCode}/${data.employeeNumber}/${data.typeCode}/${data.pattMenuId}`, {spinner: false})
      .then(response => response);
  }


  // health 체크
  onHealth() {
    return axios.get(`${this.apiUrl}/health`)
      .then(response => response);
  }

  // 메뉴
  onGetMenu(uId) {
    return axios.get(`${this.apiUrl}/menu/${uId}`)
      .then(response => response);
  }

  // 통합 검색
  searchStartApi(keyword) {
    console.log('통합검색 보내는 keyword : ', keyword)
    const map = {
      keyword: keyword
    }
    return axios.post(`${this.apiUrl_g}/TotalSearch`, map)
      .then(response => response);
  }



  //상세검색
  detailSearchApi(params) {
    console.log('상세 통합검색 보내는 params : ', params)
    const map = {
      keyword: {
        "PROJECT_NUMBER": params.projectNumber,            ///////////////////// 투자코드
        "BIZ_TYPE_CODE": params.bizTypeCode,                           ///////////////////// 사업유형
        "INVESTMET_REGIST_NM": params.investmetRegistNm,    ///////////////////// 투자부문
        "INVEST_CATEGORY_CODE":params.investCategoryCode,          ///////////////////// 투자코드
        "BIZ_REG_CODE": params.bizRegCode,          ///////////////////// 접수번호
        "INVEST_PROG_LEVEL_NAME": params.investProgLevelName,      ///////////////////// 진행구분
        "WORKS_CODE": params.worksCode,                          ///////////////////// 사소구분
        "INVEST_PURPOSE_CODE": params.investPurposeCode,               ///////////////////// 투자목적
        "PLMMEMBER_MEMB": params.plmMemberMemb,              ///////////////////// 멤버검색
        "PLMMEMBER_RESPON_KEY": params.plmMemberResponKey,          ///////////////////// 역할검색
        "P_START120": params.pStart120,                 ///////////////////// 일정검색(from: start)
        "P_END120": params.pEnd120,                    ///////////////////// 일정검색(to: end)
      }
    }

    return axios.post(`${this.apiUrl_g}/TotalSearch`, map)
      .then(response => response);
  }

  onFindInvestProgLevelNamLov() { //진행구분
    return axios.get(`${this.apiUrl_r}/o10g014081/findInvestProgLevelNamLov`, {spinner: false})
      .then(response => response);
  }



  //로그인아이디패스워드 체크
  onLoginCheckById(id) {
    return axios.get(`${this.apiUrl_r}/loginCheck/loginCheckById/${id}`)
      .then(response=>{
        return response.data});
  }



}

export default PortalRepository;
